(function (ng, app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew",
                    {
                        url: "/MarketingTrackerNew",
                        component: "marketingTrackerNew",
                        PageTitle: "Marketing Tracker",
                        params: { mtLoad: true },
                        requiredPermissions: "MarketingTracker:View",
                        resolve: {
                            delegateId: ["permissionService", function (permissionService) {
                                return permissionService.getUserDelegateId();
                            }],
                            marketingTrackerToken: ["marketingTrackerApi", "marketingTrackerAuthService", function (marketingTrackerApi, marketingTrackerAuthService) {
                                return marketingTrackerApi.getToken().then(function (token) {
                                    marketingTrackerAuthService.setAccessToken(token);
                                    return token;
                                });
                            }],
                            startLoader: ["$state", "$timeout", "$transitions", function ($state, $timeout, $transitions) {
                                $transitions.onSuccess({},
                                    function (transition) {
                                        var mtLoader = false,
                                            fromState = transition.from().name,
                                            toState = transition.to().name;

                                        //console.log('includes mtNew?', toState.includes('Home.Tools.MarketingTrackerNew'));
                                        //console.log('from includes mtNew?', fromState.includes('Home.Tools.MarketingTrackerNew'));
                                        //console.log('from is !!?', !!fromState);

                                        if (toState.includes('Home.Tools.MarketingTrackerNew')) {
                                            mtLoader = !!fromState
                                                ? fromState.includes('Home.Tools.MarketingTrackerNew')
                                                    ? false
                                                    : true
                                                : true;
                                        }
                                        $state.params.mtLoad = mtLoader;
                                    });

                            }],
                            portalUser: ["userApi", function (userApi) {
                                return userApi.getLoggedInUser()
                                    .then(function (user) {
                                        return {
                                            UserId: user.Id,
                                            User: user
                                        };
                                    });
                            }],
                            currentYear: function () {
                                return (new Date()).getUTCFullYear();
                            },
                            years: function () {
                                var currentYear = (new Date()).getUTCFullYear(),
                                    years =[];
                                for (var i = currentYear - 5; i <= currentYear + 1; i++) {
                                    years.push(i);
                                }

                                return years;
                            },
                        },
                        redirectTo: function (trans) {
                            var resolveUser = trans.injector().getAsync('portalUser');
                            return resolveUser.then(function (user) {
                                var permissionService = trans.injector().get('permissionService');
                                var canViewSalesTracker = permissionService.hasOnePermission("SalesTracker:View");
                                var currentYear = (new Date()).getUTCFullYear();
                                if (canViewSalesTracker) {
                                    return {
                                        state: "Home.Tools.MarketingTrackerNew.Dashboard",
                                        params: { SalesYear: currentYear }
                                    };
                                } else {
                                    return {
                                        state: "Home.Tools.MarketingTrackerNew.Events.EventsSummary.Cumulative",
                                        params: { SummaryYear: currentYear }
                                    };
                                }
                            });
                        }
                    });
        }
    ]);

    app
        .component("marketingTrackerNew",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/marketingtracker-new-template.html",
                controller: marketingTrackerNewController,
                bindings: {
                    user: "<",
                    delegateId: "<",
                    delegates: "<",
                    onBehalfOfUser: "<",
                    startLoader: "<",
                    logo: '<',
                    userGroup: '<',
                    currentYear: '<',
                    years: '<',
                }
            });

    marketingTrackerNewController.$inject = [
        "amplitudeService", "featureToggleService", "$mdSidenav", "marketingTrackerUserApi", "$state", "$timeout", "$transitions", "permissionService"];
    function marketingTrackerNewController(
        amplitudeService, featureToggleService, $mdSidenav, marketingTrackerUserApi, $state, $timeout, $transitions, permissionService) {
        const $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    isAdmin: false
                },
                subNavIsOpen: false,
                toggleSubNav: toggleSubNav,
            });


        function toggleSubNav(val) {
            if (val === true) {
                $ctrl.subNavIsOpen = true;
            } else {
                $ctrl.subNavIsOpen = false;
            }
        }

        function actingUserIsAdminstrator() {
            marketingTrackerUserApi.actingUserIsAdminstrator()
                .then(function (result) {
                    $ctrl.ui.isAdmin = result ? true : false;
                })
                .catch(function () {
                    console.log("Acting User is not Adminstrator");
                });
        }

        //$ctrl.load = function () {
        //    $timeout(function () {
        //        $(".marketing-tracker-preloader .preloader").addClass("active");
        //    })
        //        .then(function () {
        //            return $timeout(function () {
        //                $("#preloader-section .preloader").addClass("exit");
        //            }, 2500);
        //        })
        //        .then(function () {
        //            return $timeout(function () {
        //                //$("#preloader-section").remove();
        //                $("#preloader-section .preloader")
        //                    .removeClass("active")
        //                    .removeClass("exit");
        //            }, 1000);
        //        });
        //};

        $ctrl.toggleSideNav = function (navId) {
            $mdSidenav(navId).toggle();
        }

        $ctrl.$onInit = function () {
            //if ($state.params.mtLoad) { $ctrl.load(); }
            $ctrl.toggleFeature = featureToggleService.checkEnv();
            actingUserIsAdminstrator();
            $ctrl.canViewSalesTracker = permissionService.hasOnePermission("SalesTracker:View");
        };
    }

})(window.angular, window.app); //jshint ignore:line